import { SortOrderType } from 'models';
import { DELIVERY_STATUS_FAILED, DELIVERY_STATUS_UNSENT } from './constants';
import { Delivery } from './models/delivery';

export function checkIsDeliveryFailedOrUnsent(deliveryStatusId: number) {
  return deliveryStatusId === DELIVERY_STATUS_UNSENT || deliveryStatusId === DELIVERY_STATUS_FAILED;
}

export function sortDeliveryData(data: Delivery[], sortBy: string, sortOrder: SortOrderType) {
  switch (sortBy) {
    case 'delivery_date':
      if (sortOrder === 'asc') {
        data.sort((a, b) => {
          let da = new Date(a[sortBy]),
            db = new Date(b[sortBy]);
          return da.getDate() - db.getDate();
        });
      } else {
        data.sort((a, b) => {
          let da = new Date(a[sortBy]),
            db = new Date(b[sortBy]);
          return db.getDate() - da.getDate();
        });
      }
      break;

    case 'unit':
    case 'sale_target':
    case 'content':
    case 'approval_status':
      if (sortOrder === 'asc') {
        data.sort((a, b) => {
          let fa = a[sortBy].toLowerCase(),
            fb = b[sortBy].toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      } else {
        data.sort((a, b) => {
          let fa = a[sortBy].toLowerCase(),
            fb = b[sortBy].toLowerCase();

          if (fa < fb) {
            return 1;
          }
          if (fa > fb) {
            return -1;
          }
          return 0;
        });
      }
      break;
    case 'delivery_status':
      if (sortOrder === 'asc') {
        data.sort((a, b) => {
          return (a[sortBy] as number) - (b[sortBy] as number);
        });
      } else {
        data.sort((a, b) => {
          return (b[sortBy] as number) - (a[sortBy] as number);
        });
      }
      break;
    default:
      if (sortOrder === 'asc') {
        data.sort((a, b) => {
          return a.id - b.id;
        });
      } else {
        data.sort((a, b) => {
          return b.id - a.id;
        });
      }
      break;
  }

  return data;
}
